(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReportPaymentsPosted',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('#reportpaymentsposted-payment_type').change(function paymentTypeChanged() {
			if ($(this).val() === '3') {
				$('.credit-card-types').removeClass('hidden');
			} else {
				$('.credit-card-types').addClass('hidden');
			}
		});
	};

}(jQuery, window.Adzuki || {}));